import { Stack, Typography } from "@mui/material";

const actions = [
  "1. Review CRM intel summary and prospect contact context.",
  "2. Exchange notes with in-house AE or Solutions Expert (if possible) to align on positioning.",
  "3. Launch LinkedIn and email outreach within 1 business day of contact handover.",
];

export const SDRActions = () => {
  const border = "3px solid #59BFCF";
  return (
    <Stack paddingY={"12px"}>
      <Stack
        sx={{
          paddingY: "24px",
          gap: "16px",
          borderTop: border,
          borderBottom: border,
        }}
      >
        <Typography
          component="h5"
          sx={{
            color: "#232323",
            fontSize: "22px",
            fontWeight: 600,
            lineHeight: "28px",
          }}
        >
          Immediate SDR actions (Day 0–3)
        </Typography>
        <Stack gap={"8px"}>
          {actions.map((action) => (
            <Typography
              key={action}
              sx={{
                color: "#024760",
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "22px",
              }}
            >
              {action}
            </Typography>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};
